<template>
  <div class="anz-posts">
    <template v-for="post in postList" :key="post.id">
      <post-single
        v-if="post.post"
        :post-root="post"
        :show-report-button="!isShowingCurrentUser"
        open-respond-page
        show-link-to-topic
        :show-ip="isShowingCurrentUser && showIp"
        :hide-username="hideUsername"
        :show-author-above="showAuthorAbove"
        :hide-user-blog="hideUserBlog"
        :allow-author-seen-badge="allowAuthorSeenBadge"
        :hide-footer="hideFooter"
        :show-content-author="contentAuthor"
        :show-parent-annotation="showParentAnnotation"
        box-post
        strip-long-text
        :strip-long-text-length="183"
        strip-long-text-suffix="..."
        :strip-long-text-button="false"
      >
      </post-single>
    </template>
  </div>
  <a-loader v-if="loadingList" class-name="my-l"></a-loader>
  <div class="anz-align-center">
    <a-button
      class-name="anz-btn anz-btn-primary anz-wf-mo anz-btn-l"
      @click="loadNext"
      v-if="hasNext"
    >
      <template #title>
        {{ $translate('profile.actions.loadNext') }}
        <template v-if="totalCount > loadedCount">
          ({{ totalCount - loadedCount }})
        </template>
      </template>
    </a-button>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import PostSingle from '@/components/Post/PostSingle.vue'
import ALoader from '@/components/ALoader.vue'
import AButton from '@/components/Forms/AButton.vue'
import { useProfileShow } from '@/composables/user/user'
import useUserPostLoader from '@/composables/post/userPostLoader'

export default defineComponent({
  name: 'ProfilePostList',
  components: {
    AButton,
    PostSingle,
    ALoader,
  },
  props: {
    allowNest: {
      type: Boolean,
      default: true,
    },
    showIp: {
      type: Boolean,
      default: false,
    },
    hideUsername: {
      type: Boolean,
      default: false,
    },
    hideUserBlog: {
      type: Boolean,
      default: false,
    },
    allowAuthorSeenBadge: {
      type: Boolean,
      default: false,
    },
    showAuthorAbove: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    contentAuthor: {
      type: String,
      default: '',
    },
    showParentAnnotation: {
      type: Boolean,
      default: false,
    },
  },
  async setup() {
    const {
      postTree,
      postList,
      hasNext,
      loadNext,
      totalCount,
      loadedCount,
      loadingList,
      clearListData,
    } = useUserPostLoader()
    const { isShowingCurrentUser } = useProfileShow()

    clearListData()
    await loadNext()

    return {
      totalCount,
      loadedCount,
      loadingList,
      postTree,
      postList,
      hasNext,
      loadNext,
      scrollTo,
      isShowingCurrentUser,
    }
  },
})
</script>
